/**
 * A production worfkflow for a place with a list of phases
 *
 * @name Configuration
 * @class
 * @augments TmrResource
 */
export const factory = [
  'ProductionWorkflow',
  /*@ngInject*/ (TmrResource, Place) => {
    let referencedProperties = [
      // productionWorkflow.worker property will be instantiated as a Place resource
      { property: 'worker', resource: Place },
    ]
    let defaultValues = () => ({
      phases: [],
    })
    let ProductionWorkflow = TmrResource(
      'ProductionWorkflow',
      {},
      referencedProperties,
      defaultValues
    )

    /**
     * Override default label property.
     *
     * @method ProductionWorkflow#getLabelProperty
     */
    ProductionWorkflow.getLabelProperty =
      ProductionWorkflow.prototype.$getLabelProperty = () => 'name'

    return ProductionWorkflow
  },
]
